import { ResourceBuilder } from '@salsita-ai/platform-project-sdk/domain';
export const resources = new ResourceBuilder().addLink({
    type: 'ConfigurationLink',
    name: 'ownerLink'
}).addPdf({
    type: 'Pdf',
    name: 'pdf',
    s3Key: 'pdf'
}).addClientGeneratedImage({
    clientGenerated: true,
    type: 'Image',
    name: 'sketching',
    s3Key: 'sketching'
}).build();

//# sourceMappingURL=resources.js.map